import { useCallback } from 'react';

import {
  Document,
  LocalFile,
  useCreateMediaShareLinkMutation,
} from '@graphql/generated';
import { getDocumentIds } from '@utils/getDocumentIds';

export const useShareImagesLink = () => {
  const [createMediaShareLink] = useCreateMediaShareLinkMutation();

  const onShareImages = useCallback(
    async (
      selectedDocuments: Array<Document | LocalFile>
    ): Promise<string | null> => {
      if (!selectedDocuments || selectedDocuments.length === 0) return null;
      if (typeof globalThis.location?.origin !== 'string') return null;

      // LocalFile.id is a UUID clientId (multiple dashes); getDocumentIds
      // splits on '-' to unwrap composite ids and would truncate it, so
      // exclude anything that isn't a persisted Document before sharing.
      const documents = selectedDocuments.filter(
        (item): item is Document => item.__typename === 'Document'
      );
      if (documents.length === 0) return null;

      try {
        const result = await createMediaShareLink({
          variables: { documentIds: getDocumentIds(documents) },
        });
        const token = result.data?.createMediaShareLink?.token;
        if (!token) return null;

        return `${globalThis.location.origin}/images-preview/${token}`;
      } catch (error) {
        console.error('Error generating media share link:', error);
        return null;
      }
    },
    [createMediaShareLink]
  );

  return { onShareImages };
};
